var _circle, _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRoundLand(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 169,
    height: 169,
    viewBox: "0 0 169 169",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 84.5,
    cy: 84.5,
    r: 84.5,
    fill: "#2BBFDC",
    fillOpacity: 0.12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M109.239 112.903C106.138 112.903 103.036 112.903 99.9341 112.903C100.104 111.375 100.317 109.89 100.444 108.362C100.614 106.154 100.486 103.905 99.8491 101.782C99.1268 99.3627 97.8096 97.4525 95.4302 96.4338C92.9233 95.3726 90.374 95.3726 87.8246 96.264C85.1478 97.1979 82.9808 98.8533 80.9838 100.848C77.4997 104.329 74.8653 108.446 72.4434 112.734C72.4009 112.776 72.4009 112.861 72.4009 112.946C67.8546 112.946 63.3082 112.946 58.7193 112.946C56.5524 112.097 56 111.29 56 108.913C56 107.046 56 105.22 56 103.353C56 103.141 56 102.971 56 102.758C56.2549 102.674 56.4674 102.631 56.6798 102.546C63.6481 100.679 68.1945 96.2216 70.5739 89.4724C71.3812 87.2227 71.5511 84.8456 71.8061 82.511C72.2735 78.436 74.9078 75.5071 78.9443 74.7855C80.8563 74.446 82.7684 74.2337 84.6804 74.0215C89.3117 73.5121 92.201 71.0077 93.5182 66.6356C94.2405 64.301 94.368 61.8815 94.198 59.462C94.2405 58.6555 94.198 57.849 94.113 57.0424C94.2405 57.0424 94.2405 57 94.283 57C99.1268 57 104.013 57 108.857 57C109.749 57 110.514 57.382 111.066 58.0612C111.449 58.5706 111.661 59.1648 111.959 59.7166C111.959 64.683 111.959 69.6069 111.959 74.5733C110.556 74.3186 109.154 74.0639 107.752 73.8941C105.585 73.597 103.461 73.5121 101.294 73.9366C98.0221 74.6157 96.3225 76.6957 96.3225 80.049C96.3225 82.5534 97.3423 84.5909 99.0418 86.3313C101.251 88.581 103.971 89.9818 106.86 91.0854C108.517 91.7221 110.259 92.2739 111.959 92.8258C111.959 98.5986 111.959 104.414 111.959 110.187C111.576 111.63 110.684 112.521 109.239 112.903Z",
    fill: "url(#paint0_linear_360_27601)",
    fillOpacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M96.6626 112.904C89.8218 112.904 82.981 112.904 76.0977 112.904C76.3951 112.395 76.6925 111.885 77.0324 111.376C78.9869 108.235 81.1114 105.221 83.7883 102.674C85.4029 101.146 87.1449 99.8302 89.2694 99.2359C92.4986 98.3445 96.1527 99.1086 96.96 104.033C97.2999 105.985 97.2149 107.938 97.0025 109.89C96.9175 110.909 96.79 111.928 96.6626 112.904Z",
    fill: "url(#paint1_linear_360_27601)",
    fillOpacity: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M111.958 89.3439C108.559 88.3676 105.287 87.1791 102.483 84.9718C101.378 84.1229 100.443 83.1041 99.9335 81.7458C98.9562 79.1565 100.103 77.2888 102.865 76.9492C105.117 76.6521 107.327 77.0341 109.536 77.4586C110.343 77.6284 111.151 77.7982 112 77.968C111.958 81.7458 111.958 85.5236 111.958 89.3439Z",
    fill: "url(#paint2_linear_360_27601)",
    fillOpacity: 0.6
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M56 99.3202C56 99.108 56 98.8958 56 98.6835C56 86.0341 56 73.3423 56 60.6929C56 58.3159 57.3172 57 59.6966 57C69.8516 57 80.0066 57 90.119 57C90.3315 57 90.5015 57 90.8414 57C90.9263 58.2734 91.0113 59.462 91.0538 60.6929C91.0963 62.5606 90.9263 64.3859 90.289 66.1687C89.3967 68.6731 87.7396 70.2436 85.0203 70.6257C83.0658 70.8804 81.1113 71.0926 79.1568 71.3897C74.143 72.1538 70.6589 74.828 69.1292 79.7095C68.6194 81.3225 68.4919 83.0628 68.2795 84.7607C67.6421 89.6846 65.5176 93.8021 61.4811 96.8158C59.9515 97.9619 58.2095 98.726 56.3824 99.2353C56.2549 99.2778 56.17 99.2778 56 99.3202Z",
    fill: "url(#paint3_linear_360_27601)",
    fillOpacity: 0.6
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_360_27601",
    x1: 56.0016,
    y1: 84.9689,
    x2: 111.965,
    y2: 84.9689,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#024E82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0096B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_360_27601",
    x1: 76.0983,
    y1: 105.908,
    x2: 97.191,
    y2: 105.908,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#024E82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0096B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_360_27601",
    x1: 99.5902,
    y1: 83.0929,
    x2: 112.002,
    y2: 83.0929,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#024E82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0096B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_360_27601",
    x1: 56.001,
    y1: 78.157,
    x2: 91.0638,
    y2: 78.157,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#024E82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0096B3"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundLand);
export default __webpack_public_path__ + "static/media/round-land.edcfc7f88e74a582b6c01bad72729020.svg";
export { ForwardRef as ReactComponent };